var React = require('react');

function Maximize (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 2v2h6.586L18 12.582 19.414 14 28 5.414V12h2V2H20ZM14 19.416 12.592 18 4 26.586V20H2v10h10v-2H5.414L14 19.416ZM30 20h-2v6.586L19.418 18 18 19.414 26.586 28H20v2h10V20ZM12.584 14 14 12.592 5.414 4H12V2H2v10h2V5.414L12.584 14Z","style":{"fillRule":"nonzero"}}));
}

Maximize.defaultProps = {"xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"},"viewBox":"0 0 32 32"};

module.exports = Maximize;

Maximize.default = Maximize;
